var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Autosuggest',{attrs:{"model":_vm.displayText,"suggestions":_vm.localOptions,"placeholder":_vm.placeholder,"suggestion-name":"fullName","limit":_vm.limit,"loading":_vm.loading || _vm.isSearching,"show-clear":_vm.showClear},on:{"update:model":function($event){_vm.displayText=$event},"change":_vm.onChange,"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }